import {
  online_help_aggiornamento_documento_identita_uni20,
  online_help_annullo_operazione_previdenziali_uni20,
  online_help_comunicazione_sinistro_uni20,
  online_help_liquidazione_scadenza_uni20,
  online_help_rettifica_anagrafica_uni20,
  online_help_riscatti_uni20,
  online_help_switch_uni20,
  online_help_variazione_beneficiario_uni20,
  online_help_variazione_cc_beneficiario_prestazione_periodica_uni20,
  online_help_variazione_contraenza_uni20,
  online_help_variazione_recapito_uni20,
  online_help_variazione_residenza_uni20,
  online_help_versamento_aggiuntivo_uni20,
} from './online-help-uni20-operation.constants';
import {
  online_help_attiva_sospendi_versamenti_ricorrenti_previdenziali_uni30,
  online_help_cambio_datore_lavoro_tfr_previdenziali_uni30,
  online_help_cambio_linea_gestione_previdenziali_uni30,
  online_help_reindirizzamento_riallocazione_fondo_previdenziali_uni30,
  online_help_riattivazione_versamenti_ricorrenti_previdenziali_uni30,
  online_help_variazione_beneficiario_caso_morte_previdenziali_uni30,
  online_help_variazione_coordinate_bper_addebito_previdenziali_uni30,
  online_help_variazione_data_addebito_previdenziali_uni30,
  online_help_variazione_data_pensionamento_previdenziali_uni30,
  online_help_variazione_documento_identita_previdenziali_uni30,
  online_help_variazione_importo_versamento_piano_ricorrente_previdenziali_uni30,
  online_help_variazione_pagatore_previdenziali_uni30,
  online_help_variazione_periodicita_piano_ricorrente_previdenziali_uni30,
  online_help_variazione_recapito_postale_previdenziali_uni30,
  online_help_variazione_residenza_previdenziali_uni30,
  online_help_versamenti_integrativo_conto_bper_previdenziali_uni30,
} from './online-help-uni30-operation.constants';

export interface IOnlineHelpSection {
  sectionTitle: string;
  sectionDescription: string[];
}

export interface IOnlineHelp {
  url: string;
  urlParam?: string[];
  headerTitle: string;
  headerDescription: string;
  sections: IOnlineHelpSection[];
}

const online_help_operations_download_upload_description = {
  sectionTitle: null,
  sectionDescription: [
    '<strong>Tale conferma consente di visualizzare la pagina di download dei documenti da stampare e far firmare al cliente.</strong>',
    'Solamente dopo aver eseguito il download, sarà possibile cliccare sul tasto “Avanti”; l’operatore atterra sulla pagina di Caricamento della documentazione (Upload) nella quale è obbligatorio caricare la modulistica firmata dal cliente e scannerizzata in corrispondenza della lista proposta a sistema.',
    'Una volta caricati i documenti e cliccando il tasto “Conferma” l’iter relativo all’operazione risulta concluso.',
    '<strong>N.B</strong>: qualora non venga effettuato l’upload dei documenti, l’operazione rimarrà in stato “documenti da caricare” e non sarà possibile eseguire una nuova operazione.',
    'A seguito dell’upload della documentazione firmata e scannerizzata, l’operatore deve:',
    '<ul><li>inviare la copia Direzione in Compagnia (invio per posta interna, vedi Capitolo 5 per i dettagli);</li><li>consegnare al Cliente la copia di sua competenza;</li><li>archiviare la copia Intermediario, come da Vademecum Archiviazione dei documenti da parte delle Dipendenze, pubblicato con Circolare n.218, serie Disposizioni Interne, ambito Organizzazione, del 9 novembre 2021.</li></ul>',
  ],
};

const online_help_operations_soggetto_presentatore = {
  sectionTitle: null,
  sectionDescription: [
    'Dopo aver selezionato l’operazione nella lista delle operazioni disponibili sulla polizza, la procedura, in caso di persona fisica, mostra un pop -up che riporta la seguente domanda: <strong>“Il contraente è un soggetto tutelato/assistito?”</strong>',
    '<strong>In caso di risposta positiva</strong>, è obbligatorio selezionare l’NDG del presentatore scegliendo tra quelli disponibili proposti dal sistema (è necessario selezionare lo stesso presentatore della consulenza effettuata sull’applicativo Pi.CO.).',
    '<strong>In caso di risposta negativa</strong>alla domanda, il sistema consente di procedere con l’esecuzione dell’operazione come di seguito indicato.',
    '<strong>In caso di contraente persona giuridica</strong>, la procedura obbligatoriamente richiede di selezionare l’NDG del presentatore tra quelli disponibili proposti dal sistema (è necessario selezionare lo stesso presentatore della consulenza effettuata sull’applicativo Pi.CO.).',
  ],
};

export const online_help_home_map: IOnlineHelp = {
  url: '/home',
  headerTitle: 'Home',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La HomePage è suddivisa nelle seguenti sezioni:',
        '<ul><li><strong>Area di Ricerca: </strong>Sezione di <strong>ricerca base</strong> per NDG Banca o <strong>ricerca avanzata</strong> per altri campi specifici (Polizza, Nome, Cognome, ...).</li><li><strong>Operazioni del mese: </strong>Sezione riportante il numero delle operazioni effettuate nell’ultimo mese dalla filiale o dal private banker.</li><li><strong>Ultime operazioni: </strong>Sezione riportante l’elenco delle ultime operazioni effettuate, mostrate sulla base del profilo dell’utente. Cliccando sull’icona relativa all’operazione, l’utente viene reindirizzato alla pagina dell’operazione effettuata. All’interno della sezione “Ultime Operazioni”, selezionando la dicitura <strong>“Vai al cruscotto”</strong> è possibile ricercare le ultime operazioni attraverso una serie di criteri di ricerca (range temporale, tipologia operazione, stato operazione, …).</li></ul>',
      ],
    },
    {
      sectionTitle: null,
      sectionDescription: [
        'Inoltre <strong>cliccando nella parte alta a sinistra</strong> della pagina sarà visualizzabile il menù contenente le seguenti sezioni:',
        '<ul><li><strong>Home: </strong>permette di accedere alla Home page dell’applicativo;</li><li><strong>Ricerca: </strong>permette all’utente di effettuare una nuova ricerca;</li><li><strong>Cruscotto: </strong>permette di visualizzare il Cruscotto operazioni;</li><li><strong>Documenti: </strong>sezione nella quale è possibile scaricare la modulistica utile all’esecuzione delle operazioni manuali (ad es. Svincolo polizza, Proroga pagamento premi) non eseguibili a sistema.</li></ul>',
      ],
    },
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong>Cliccando sull’area attinente al profilo</strong> in alto a destra della pagina, è possibile visualizzare i dettagli del profilo con cui si è acceduto alla piattaforma. In particolare, sono visibili le seguenti informazioni:',
        "<ul><li>Nome e cognome utente;</li><li>Matricola;</li><li>Modalità di accesso (in sede, fuori sede);</li><li>ABI;</li><li>CAB;</li><li>FILIALE (Descrizione della Filiale e/o dell'Ufficio);</li><li>Abilitazioni legate all’utente (Piena operatività; Sola lettura; Non abilitato), relative a prodotti IBIPS, No-IBIPS e PRevidenziali. La tipologia di abilitazione dell’operatore ed i valori possibili sono visibili in maniera sintetica anche dalle icone riportate in alto a destra della pagina, che assumeranno il colore verde, giallo e rosso rispettivamente sulla base delle abilitazioni concesse (es. piena operatività sui prodotti IBIPS = icona I di colore verde).</li></ul>",
      ],
    },
  ],
};

export const online_help_search_map: IOnlineHelp = {
  url: '/search',
  headerTitle: 'Ricerca',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La <strong>consultazione delle polizze</strong> può essere effettuata attraverso due modalità:',
        '<ul><li><strong>Ricerca</strong>, in cui è possibile effettuare la ricerca per NDG</li><li><strong>Ricarca Avanzata</strong>, in cui è possibile effettuare la ricerca per:<ul><li>Numero polizza (numero polizza Banca e/o Compagnia);</li><li>Numero contratto (numero rapporto Anagrafe Banca);</li><li>Codice fiscale;</li><Nome;</li><li>Congome;</li><li>Data di nascita;</li><li>P.IVA;</li><li>Ragione sociale.</li></ul></li></ul>',
        'In entrambi casi è possibile azzerare i campi di ricerca in precedenza popolati attraverso il tasto “Reset”.',
        'In funzione del criterio di ricerca selezionato, è possibile visualizzare:',
        '<ul><li><strong>l’elenco delle polizze associate al Cliente</strong>, qualora la ricerca sia stata effettuata tramite uno dei campi riferiti al contraente (es. NDG, Nome e Cognome, Codice Fiscale, …)</li><li>la <strong>singola polizza ricercata</strong>, qualora la ricerca sia stata eseguita tramite il numero di polizza/contratto.</li></ul>',
        'Il dettaglio di ciascuna polizza è visualizzabile cliccando direttamente sul “numero polizza” di fianco al logo.',
        'Una volta selezionata la polizza è possibile consultarne i dettagli e / o eventualmente effettuare delle operazioni d’inquiry e dispositive.',
      ],
    },
  ],
};

export const online_help_policy_detail_map: IOnlineHelp = {
  url: '/policies',
  headerTitle: 'Dettaglio polizza',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'Nella pagina di dettaglio della polizza selezionata sono visibili le seguenti informazioni:',
        '<ul><li><strong>Sintesi dati generali di polizza</strong> (numero polizza, prodotto, tipologia premio, data emissione e scadenza, data fine pagamento premi e controvalore);</li><li><strong>Dettagli sul contraente</strong> (NDG, codice fiscale, data di nascita e se PF / PG);</li><li><strong>Dati di dettaglio della polizza suddivisi in macrosezioni</strong>;</li></ul>',
        'Dalla pagina di dettaglio polizza, è possibile, accedere alle seguenti tre funzionalità:',
        '<ul><li>Quietanze e pagamenti;</li><li>Operazioni effettuate;</li><li>Inserimento operazioni.</li></ul>',
      ],
    },
    {
      sectionTitle: 'Quietanze e pagamenti',
      sectionDescription: [
        'Cliccando su “Quietanze e pagamenti” la procedura consente la visualizzazione dell’elenco delle quietanze addebitate e dei pagamenti effettuati sulla polizza selezionata.',
      ],
    },
    {
      sectionTitle: 'Operazioni effetuate',
      sectionDescription: [
        'Cliccando sulla funzionalità “Operazioni effettuate” viene raffigurato <strong>l’elenco delle operazioni effettuate sulla polizza</strong>. Cliccando sull’icona a destra della riga, è possibile visualizzare il dettaglio dell’operazione.',
        'Se si tratta di operazioni eseguite in giornata, sarà presente anche l’icona di cancellazione che permetterà di annullare l’operazione.',
        'Nella lista viene visualizzato anche lo Stato dell’operazione. I possibili stati sono:',
        '<ul><li><strong>"DOCUMENTAZIONE DA CARICARE"</strong>: documenti in attesa di essere caricati a sistema nella sezione “upload documentale”;</li><li><strong>"COMPLETATA"</strong>: tutti i passaggi sono stati completati correttamente in BPER Suite e l’operazione è stata inviata in Compagnia;</li><li><strong>“ANNULLATA”</strong>: operazione annullata dal gestore dopo il suo inserimento in giornata.</li></ul>',
        'È inoltre previsto lo stato <strong>“Bozza”</strong> che indica che l’operazione è stata avviata dal gestore ma non completata; cliccando sull’operazione è possibile riprenderla e concluderla o cancellarla.',
      ],
    },
    {
      sectionTitle: 'Operazioni dispositive',
      sectionDescription: [
        'Cliccando sulla funzione “Inserimento operazioni” la procedura consentirà la visualizzazione delle sole operazioni disponibili per la polizza selezionata.',
      ],
    },
  ],
};

export const online_help_operations_athora_vagg_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_VAGG'],
  headerTitle: 'Versamento aggiuntivo',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong><u>Per i Versamenti Integrativi è obbligatoria la prestazione del Servizio di Consulenza nell’applicativo Pi.Co.</u></strong>.',
      ],
    },
    online_help_operations_soggetto_presentatore,
    {
      sectionTitle: null,
      sectionDescription: [
        'Per poter procedere con l’operazione è necessario inserire i seguenti dati:',
        '<ul><li>Coordinate bancarie: la procedura mostra un menù a tendina con i conti correnti monointestati e/o cointestati legati al cliente;</li><li>Importo del premio lordo da inserire nel relativo campo; per le Multistrategia, l’importo del premio deve essere inserito sui singoli fondi che compongono la polizza, in rispetto delle regole del prodotto.</li></ul>',
        'L’operazione deve essere equivalente a ciò che è stato oggetto della Consulenza su Pi.Co., sia in termini di fondo, sia di importo (sono previsti meccanismi di controllo di tale coerenza che rendono impossibile procedere nel caso in cui vi siano differenze).',
        'Premendo il tasto “Avanti” di conferma dell’operazione, l’operatore viene indirizzato sulla pagina del sistema in cui è prevista la compilazione del questionario AML/FATCA/CRS.',
        '<strong>N.B</strong>: il sistema proporrà la compilazione del questionario AML/FATCA/CRS solamente per operazioni di importo superiore a 5.000 euro.',
        'Al termine del questionario, cliccando sul tasto Avanti, la procedura chiede la conferma di inserimento dell’operazione:',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_switch_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_SWIT', '_SWITC', '_SWITR'],
  headerTitle: 'Switch',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong><u>Per le operazioni di switch è obbligatoria la prestazione del Servizio di Consulenza nell’applicativo Pi.Co.</u></strong>.',
      ],
    },
    online_help_operations_soggetto_presentatore,
    {
      sectionTitle: null,
      sectionDescription: [
        'Tale funzionalità permette di modificare l’investimento tra le opzioni previste dal prodotto.',
        'In corrispondenza della “Linea di investimento attuale” è indicato l’investimento di partenza, mentre nel menù a tendina è selezionabile la nuova linea su cui si intende investire e finalizzare lo switch.',
        'Con la medesima funzione, <strong>per il prodotto Multistrategia / Multistrategia PAC</strong> è possibile effettuare uno switch tra rami / fondi. La sezione “Disinvestimento” riporta lo stato attuale dei fondi tramite una sezione riepilogativa in cui è previsto il campo “Importo da disinvestire”, compilabile dall’utente.',
        'Nello step “Investimento”, invece l’utente dovrà selezionare i fondi su cui effettuare lo switch in e indicare l’importo da investire.',
        'Lo Switch deve essere equivalente a ciò che è stato oggetto della Consulenza su Pi.Co., sia in termini di fondo/linea, sia di importo (sono previsti meccanismi di controllo di tale coerenza che rendono impossibile procedere nel caso in cui vi siano differenze).',
        'La procedura chiede, poi, la conferma di inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_vcbmu_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_VCBMU'],
  headerTitle: 'Variazione conto corrente',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La variazione del conto corrente è possibile a condizione che:',
        '<ul><li>il Contraente della polizza sia intestatario o cointestatario del conto sul quale deve essere appoggiata la polizza;</li><li>il conto sia attivo (non bloccato).</li></ul>',
        'Cliccando su questa funzionalità la procedura consente la <strong>variazione del conto di riferimento della polizza, solo</strong> tra quelli disponibili proposti dal sistema.',
        'Una volta selezionato il conto è possibile premere “Avanti”.',
        'La procedura chiede, poi, la conferma di inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_vprfr_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_VPRFR'],
  headerTitle: 'Variazione premio periodicità',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'Accedendo a tale funzione, la procedura propone una videata nella quale è <strong>possibile variare singolarmente o congiuntamente la periodicità e l’importo del premio</strong>.',
        'La procedura chiede, poi, la conferma di inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_inpag_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_INPAG'],
  headerTitle: 'Sospensione pagamento premi (Ibips e No Ibips)',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La funzione di Sospensione del versamento dei premi permette di sospendere il <strong>pagamento dei premi periodici relativi alla polizza</strong>.',
        'Cliccando sul tasto “Avanti”, l’operazione viene inviata alla Compagnia e viene visualizzata la pagina di download dei documenti <strong>da stampare e far firmare al cliente</strong>.',
      ],
    },
    online_help_operations_download_upload_description,
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong>N.B.: la Sospensione del versamento dei premi ha effetto dalla prima ricorrenza utile.</strong>',
      ],
    },
  ],
};

export const online_help_operations_athora_riapu_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_RIAPU'],
  headerTitle: 'Sospensione pagamento premi (solo Ibips)',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La funzione di Riattivazione pagamento premi permette di riattivare il <strong>pagamento dei premi periodici relativi alla polizza</strong>.',
        'Cliccando sul tasto “Avanti”, l’operazione viene inviata alla Compagnia e viene visualizzata la pagina di download dei documenti da atrong>stampare e far firmare al cliente</strong>.',
      ],
    },
    online_help_operations_download_upload_description,
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong>N.B.: la Riattivazione del versamento dei premi ha effetto dalla prima ricorrenza utile.</strong>',
      ],
    },
  ],
};

export const online_help_operations_athora_vcont_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_VCONT'],
  headerTitle: 'Variazione Contraenza',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'Questa funzione consente di <strong>variare il Contraente della polizza</strong>.',
        'Dopo aver selezionato l’operazione nella lista delle operazioni disponibili sulla polizza, la procedura richiede l’inserimento dell’NDG del nuovo Contraente.',
        'Dopo aver cliccato sul tasto Ricerca, viene visualizzato il soggetto ricercato ed è necessario selezionare il conto corrente, nel menù a tendina, da associare alla polizza.',
        '<strong>L’operazione NON è ammessa se il contraente subentrante non è correntista della Banca.</strong>',
        'Premendo il tasto “Avanti”, l’operatore viene indirizzato sulla pagina del sistema in cui è prevista la compilazione del questionario AML/FATCA/CRS. Dopo aver compilato il questionario, cliccando sul tasto Avanti la procedura chiede la conferma dell’inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

const vbene_beneficiario_generico_description =
  '<ul><li>Il coniuge o in mancanza i figli;</li><li>Eredi legittimi;</li><li>Eredi testamentari, in mancanza eredi legittimi;</li><li>I figli in parti uguali;</li><li>Il coniuge;</li><li>Il coniuge e i figli in parti uguali;</li><li>I genitori in parti uguali.</li></ul>';
const vbene_beneficiario_designato_description =
  '<ul><li>Tipologia persona: Persona fisica/ Persona giuridica;</li><li>Tipo beneficiario (precompilato solo caso Morte);</li><li>Nome / Cognome;</li><li>Data di nascita (per le persone giuridiche data di costituzione società);</li><li>Codice Fiscale / P.IVA;</li><li>Quota;</li><li>Capitale sociale, solo per persone giuridiche;</li><li>Relazione tra beneficiario e contraente;</li><li>Nazionalità;</li><li>Sesso;</li><li>Luogo di nascita (Nazione, Provincia, Comune);</li><li>Luogo di residenza (Nazione, Provincia, Comune, Cap, Toponimo, Indirizzo, Numero civico).</li></ul>';

export const online_help_operations_athora_vbene_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_VBENE'],
  headerTitle: 'Variazione di Beneficiario caso morte',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'Dopo aver selezionato l’operazione nella lista delle operazioni disponibili sulla polizza, la procedura mostra la Lista dei beneficiari di polizza soggetti a modifica.',
        'La modifica è consentita eliminando l’/gli attuale/i beneficiario/i e cliccando sul tasto “Aggiungi Beneficiario”.',
        'É necessario procedere all’inserimento dei dati del nuovo beneficiario di polizza scegliendo tra:',
        '<ul><li>beneficiari generici:' +
          vbene_beneficiario_generico_description +
          '</li><li>beneficiarfio designato (specifico) per il quale sarà richiesta, dopo la selezione della tipologia di persona (PF o PG), la compilazione dei seguenti dati obbligatori:' +
          vbene_beneficiario_designato_description +
          '</li></ul>',
        'Dopo aver inserito tutti i dati, la procedura chiede la conferma dell’inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_vrecp_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_VRECP'],
  headerTitle: 'Variazione di recapito',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La funzione consente di modificare l’indirizzo di corrispondenza della polizza.',
        'Dopo aver selezionato l’operazione nella lista delle operazioni disponibili sulla polizza, la procedura propone i campi da modificare relativi al nuovo indirizzo di recapito del Contraente.',
        'Cliccando sul tasto Avanti, la procedura chiede la conferma di inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong>N.B.: Tale variazione non modifica i dati anagrafici del Cliente (ossia la residenza) ma solo l’indirizzo di invio della corrispondenza.</strong>',
      ],
    },
  ],
};

export const online_help_operations_athora_simor_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_SIMOR'],
  headerTitle: 'Comunicazione sinistro',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La funzione di “comunicazione di sinistro” consente di comunicare alla Compagnia il <strong>decesso del soggetto assicurato.</strong>',
        'Dopo aver selezionato l’operazione nella lista delle operazioni disponibili sulla polizza, è necessario compilare i dati richiesti:',
        '<ul><li>data decesso;</li><li>causa decesso;</li><li>dati del dichiarante.</li></ul>',
        'Per aggiungere uno o più Beneficiari PF/PG è necessario cliccare sul tasto “Aggiungi beneficiario”, in cui è possibile la <strong>compilazione manuale dei dati anagrafici</strong> oppure effettuare la <strong>ricerca per NDG</strong> (solo se censito in anagrafe Banca).',
        'In entrambi i casi è necessario specificare i seguenti dati:',
        '<ul><li>Iban beneficiario;</li><li>Relazione tra beneficiario e contraente;</li><li>Quota beneficiario.</li></ul>',
        'In corrispondenza di ciascun beneficiario inserito:',
        '<ul><li>Cliccando sull’icona “Compila questionario” si apre una maschera per la compilazione del questionario AML/FATCA/CRS;</li><li>Cliccando sull’icona “Rimuovi” è possibile eliminare il beneficiario inserito;<li>Cliccando sull’icona “Visualizza” è possibile visualizzare e / o modificare i dati del beneficiario inserito.</li></ul>',
        'Premendo il tasto “Avanti”, la procedura chiede la conferma di inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_rispa_risto_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_RISPA', '_RISTO'],
  headerTitle: 'Riscatto totale / Riscatto parziale',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        '<strong><u>L’operazione di riscatto può essere preceduta dall’erogazione della Consulenza nell’applicativo Pi.Co. (non è obbligatoria)</u></strong>.',
      ],
    },
    online_help_operations_soggetto_presentatore,
    {
      sectionTitle: null,
      sectionDescription: [
        'Per poter effettuare una operazione di <strong>Riscatto Totale</strong> è necessario selezionare dal menù a tendina il conto da utilizzare per la liquidazione, tra quelli disponibili proposti dal sistema.',
        'Per effettuare una operazione di <strong>Riscatto parziale</strong> è necessario inserire, oltre a quanto sopra, l’importo da liquidare.',
        '<strong>Solo per i prodotti della linea Multistrategia, l’importo da liquidare dovrà essere indicato in corrispondenza di ciascun sottostante</strong>.',
        'Premendo il tasto “Avanti” di conferma dell’operazione, l’operatore viene indirizzato sulla pagina del sistema in cui è possibile la compilazione del questionario AML/FATCA/CRS.',
        'La procedura chiede, poi, la conferma di inserimento dell’operazione.',
        '<strong>N.B.: l’iter di richiesta del codice autorizzativo per riscatto totale e riscatto parziale resta invariato</strong>.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_scopz_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_SCOPZ'],
  headerTitle: 'Liquidazione a scadenza',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'Se il prodotto è a scadenza, <strong>a partire dal 30° giorno antecedente la data di scadenza</strong>, il sistema consente di selezione la funzione di Opzione a scadenza.',
        'Per poter effettuare una operazione di <strong>Opzione a scadenza</strong> è necessario selezionare dal menù a tendina il conto da utilizzare per la liquidazione, tra quelli disponibili proposti dal sistema.',
        'Premendo il tasto “Avanti” di conferma dell’operazione, l’operatore viene indirizzato sulla pagina del sistema in cui è possibile la compilazione del questionario AML/FATCA/CRS.',
        'La procedura chiede, poi, la conferma di inserimento dell’operazione.',
      ],
    },
    online_help_operations_download_upload_description,
  ],
};

export const online_help_operations_athora_annullo_map: IOnlineHelp = {
  url: '/ath/operations',
  urlParam: ['_ANAPP', '_ARIST', '_ARISP'],
  headerTitle: 'Funzionalità di Annullo operazione',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'La funzione di “Annullo” consente di annullare, <strong>esclusivamente nella giornata di inserimento</strong>, una operazione inserita in procedura.',
        'Tale funzionalità è valida solo per le operazioni che non hanno necessità di una valutazione da parte della Compagnia. In particolare, l’annullo<strong> non può essere effettuato in procedura</strong> per l’operazione di Variazione Contraenza o in casi particolari come, ad esempio, Versamento integrativo / Riscatto su persona politicamente esposta. In tali casi è necessario contattare la Compagnia per procedere eventualmente con l’annullo.',
        'Cliccando sulla funzionalità “Operazioni effettuate”, in corrispondenza di ciascuna operazione, se si tratta di operazioni eseguite in giornata, viene raffigurata l’icona di cancellazione che permetterà di annullare l’operazione.',
        "Se l’annullo è eseguibile è necessario cliccare sull'icona di cancellazione e procedere cliccando il tasto “AVANTI” per effettuare l’operazione.",
        'La procedura chiede, poi, la conferma di inserimento dell’operazione.',
        '<strong>Esclusivamente per le operazioni di Riscatto Parziale e Riscatto Totale tale conferma prevede la produzione del documento da stampare (in tutti gli altri casi, non è previsto la stampa del modulo di annullo)</strong>.',
        'L’operazione annullata può essere visualizzata sulla pagina di riepilogo delle ultime operazioni.',
      ],
    },
  ],
};

export const online_help_dashboard_map: IOnlineHelp = {
  url: '/dashboard',
  headerTitle: 'Cruscotto',
  headerDescription: null,
  sections: [
    {
      sectionTitle: null,
      sectionDescription: [
        'Nella sezione <strong>Cruscotto</strong> è possibile ricercare le operazioni effettuate secondo i seguenti criteri di ricerca:',
        "<ul><li><strong>Operazione</strong>: nome dell'operazione effettuata</li><li><strong>Matricola</strong>: matricola dell'utente che ha effettuato l'operazione</li><li><strong>Filiale</strong>: filiale di gestione della polizza su cui è avvenuta l'operazione</li><li><strong>Stato</strong>: stato dell'operazione (Bozza, Doc. da caricare, Completata)</li><li><strong>Periodo temporale</strong>: range temporale in cui è stata effettuata l'operazione</li></ul>",
      ],
    },
  ],
};

export const online_help_documents_map: IOnlineHelp = {
  url: '/documents',
  headerTitle: 'Documenti',
  headerDescription:
    "Nella sezione Documenti è possibile scaricare la modulistica utile all'esecuzione delle operazioni manuali non eseguibili da sistema",
  sections: [],
};

export const online_help_tdb: IOnlineHelp = {
  url: '',
  headerTitle: 'TDB',
  headerDescription: 'TBD',
  sections: [
    {
      sectionTitle: 'To Be Defined',
      sectionDescription: [
        'Il testo completo della guida in linea arriverà una volta definito il manuale operativo',
      ],
    },
  ],
};

export const base_online_help_map: IOnlineHelp[] = [
  online_help_home_map,
  online_help_search_map,
  online_help_policy_detail_map,
  online_help_dashboard_map,
  online_help_documents_map,
  online_help_tdb,
];

export const athora_online_help_map: IOnlineHelp[] = [
  ...base_online_help_map,
  online_help_operations_athora_vagg_map,
  online_help_operations_athora_switch_map,
  online_help_operations_athora_vcbmu_map,
  online_help_operations_athora_vprfr_map,
  online_help_operations_athora_inpag_map,
  online_help_operations_athora_riapu_map,
  online_help_operations_athora_vcont_map,
  online_help_operations_athora_scopz_map,
  online_help_operations_athora_vbene_map,
  online_help_operations_athora_vrecp_map,
  online_help_operations_athora_simor_map,
  online_help_operations_athora_rispa_risto_map,
];

export const uni20_online_help_map: IOnlineHelp[] = [
  ...base_online_help_map,
  online_help_versamento_aggiuntivo_uni20,
  online_help_switch_uni20,
  online_help_variazione_beneficiario_uni20,
  online_help_variazione_contraenza_uni20,
  online_help_variazione_recapito_uni20,
  online_help_comunicazione_sinistro_uni20,
  online_help_riscatti_uni20,
  online_help_liquidazione_scadenza_uni20,
  online_help_rettifica_anagrafica_uni20,
  online_help_aggiornamento_documento_identita_uni20,
  online_help_variazione_residenza_uni20,
  online_help_variazione_cc_beneficiario_prestazione_periodica_uni20,
  online_help_annullo_operazione_previdenziali_uni20,
];

export const uni30_online_help_map: IOnlineHelp[] = [
  ...base_online_help_map,
  online_help_variazione_recapito_postale_previdenziali_uni30,
  online_help_variazione_residenza_previdenziali_uni30,
  online_help_variazione_documento_identita_previdenziali_uni30,
  online_help_variazione_beneficiario_caso_morte_previdenziali_uni30,
  online_help_variazione_data_pensionamento_previdenziali_uni30,
  online_help_cambio_datore_lavoro_tfr_previdenziali_uni30,
  online_help_versamenti_integrativo_conto_bper_previdenziali_uni30,
  online_help_variazione_importo_versamento_piano_ricorrente_previdenziali_uni30,
  online_help_variazione_periodicita_piano_ricorrente_previdenziali_uni30,
  online_help_attiva_sospendi_versamenti_ricorrenti_previdenziali_uni30,
  online_help_riattivazione_versamenti_ricorrenti_previdenziali_uni30,
  online_help_variazione_coordinate_bper_addebito_previdenziali_uni30,
  online_help_variazione_pagatore_previdenziali_uni30,
  online_help_variazione_data_addebito_previdenziali_uni30,
  online_help_reindirizzamento_riallocazione_fondo_previdenziali_uni30,
  online_help_cambio_linea_gestione_previdenziali_uni30,
];
